import axios from "axios";
let config = {
  baseURL: process.env.VUE_APP_URL,
  timeout: 60 * 1000, // Timeout
//   access: true,
//   changeOrigin: true,
//   withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    // 'Content-Type': 'application/json',
    'content-encoding': 'gzip',
  }
};

const _axios = axios.create(config);
export default _axios